import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Close from "./Close";

import FadeIn from "react-fade-in/lib/FadeIn";
import PhotoGallery from "./PhotoGallery";

// change text 2 to be split into array by commas
function Project(props) {
  const [project, setProject] = useState(props.project);
  const [zoomBack, setZoomBack] = useState(1);
  const [zoomColumn, setZoomColumn] = useState(1);
  useEffect(() => {
    // window.scroll(0, 0);
    console.log(document.documentElement.scrollTop);
    console.log("project opened, window scrolled?");
  }, []);
  useEffect(() => {
    if (props.project) {
      setProject(props.project);
    }
  }, [props.project]);
  useEffect(() => {
    setTimeout(() => {
      setZoomBack(1.2);
    }, 500);
  }, []);

  const curProject = props.project || project || {};
  const photos = curProject.photos || [];
  const photo0 = photos[0]?.src || "";
  const photo1 = photos[1]?.src || photo0;
  const details = curProject.details || [];
  const d0 = details[0] || { title: "", text: "" };
  const d1 = details[1] || { title: "", text: "" };
  const d2 = details[2] || { title: "", text: "" };
  const d1Parts = (d1.text || "").split(";;");
  const displayTitle = curProject.name || d0.title || curProject.id || "";

  return (
    <div>
      {/* <NavBuffer pad={80} transition={0.3}></NavBuffer> */}

      <DisplayArea>
        <FadeIn>
          <BackDrop
            style={{
              backgroundImage: photo0 ? `url(${photo0})` : "none",
              transform: `scale(${zoomBack})`,
            }}
          ></BackDrop>
        </FadeIn>

        <FadeIn>
          <BigImage
            style={{
              transition: ".1s ease",
              height: props.navbar
                ? `${window.innerHeight - 0}px`
                : `${window.innerHeight - 70}px`,
            }}
            onMouseEnter={() => {
              setZoomBack(1.2);
              console.log("Big Image");
            }}
            onMouseLeave={() => {
              setZoomBack(1);
            }}
          >
            <Close
              func={() => {
                window.history.go(-1);
              }}
            />
            <BigImageInfoBox>
              <BigImageTitle>{displayTitle}</BigImageTitle>
              <BigImageInfo>{d0.text}</BigImageInfo>
            </BigImageInfoBox>
          </BigImage>

          <RowInfo>
            <CenterText>
              {/* <CenterTextTitle>{d1.title}</CenterTextTitle> */}
              <div>{d1Parts[0] || ""}</div>
              <div>{d1Parts[1] || ""}</div>
              <div>{d1Parts[2] || ""}</div>
            </CenterText>
          </RowInfo>
          <Row>
            <ColumnImage
              onMouseEnter={() => {
                setZoomColumn(1);
              }}
              onMouseLeave={() => {
                setZoomColumn(1.2);
              }}
              style={{
                backgroundImage: photo1 ? `url(${photo1})` : "none",
                transform: `scale(${zoomColumn})`,
              }}
            ></ColumnImage>
            <ColumnInfo>
              <CenterText>
                <CenterTextTitle>{d2.title}</CenterTextTitle>
                <div>{d2.text}</div>
              </CenterText>
            </ColumnInfo>
          </Row>
        </FadeIn>
        <GalleryAreaBack>
          <GalleryTitle>GALLERY</GalleryTitle>

          <GalleryArea>
            {/* <GalleryAreaBox> */}
              <GalleryBlock id={props.dispId}>
                <PhotoGallery photos={photos} />
              </GalleryBlock>
            {/* </GalleryAreaBox> */}
          </GalleryArea>
        </GalleryAreaBack>
        <div style={{ height: "0px" }}></div>
      </DisplayArea>
    </div>
  );
}

export default Project;

const BackDrop = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #3e82be;
  background-size: cover;
  background-position: center;
  transition: 8s ease;
`;
const DisplayArea = styled.div`
  /* position: relative; */
  width: 100%;
`;

const BigImage = styled.div`
  position: relative;
  width: 100%;
`;
const BigImageTitle = styled.div`
  position: absolute;
  left: 100px;
  bottom: 100px;
  font-size: 32px;
  color: #ffffff;
  opacity: 80%;
  font-weight: 600;
  transition: 0.3s;
  @media (max-width: 768px) {
    left: 20px;
    bottom: 80px;
    font-size: 24px;
  }
`;
const BigImageInfo = styled.div`
  position: absolute;
  left: 100px;
  bottom: 50px;
  font-size: 24px;
  color: #ffffff;
  opacity: 80%;
  font-weight: 400;
  transition: 0.3s;
  @media (max-width: 768px) {
    left: 20px;
    bottom: 40px;
    font-size: 18px;
  }
`;

const BigImageInfoBox = styled.div`
  width: 100%;
  height: 180px;
  background-color: #0d0d0d50;
  position: absolute;
  left: 0px;
  bottom: 0px;
  &:hover ${BigImageInfo} {
    opacity: 100%;
  }
  &:hover ${BigImageTitle} {
    opacity: 100%;
  }
  @media (max-width: 768px) {
    height: 140px;
  }
`;
const RowInfo = styled.div`
  position: relative;
  width: 100%;
  height: 240px;
  color: #595959;
  background-color: #ffffff;
  overflow: scroll;
  @media (max-width: 768px) {
    height: auto;
    padding: 40px 0;
    overflow: visible;
  }
`;
const CenterText = styled.div`
  position: absolute;
  text-align: center;
  font-size: 20px;
  line-height: 32px;
  width: 70%;
  left: 50%;
  top: 50%;
  font-weight: 400;

  transform: translate(-50%, -50%);
  @media (max-width: 768px) {
    position: relative;
    left: 0;
    top: 0;
    transform: none;
    width: 90%;
    margin: auto;
    text-align: left;
  }
`;
const CenterTextTitle = styled.div`
  font-weight: 600;
  margin-bottom: 30px;
  font-size: 24px;
  @media (max-width: 768px) {
    font-size: 20px;
  }
`;
const Row = styled.div`
  display: flex;
  flex-direction: row;
  overflow: hidden;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
const ColumnInfo = styled.div`
  position: relative;
  width: 30%;
  height: 800px;
  background-color: #f2f2f2;
  color: #595959;
  overflow: scroll;
  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    padding: 40px 0;
    overflow: visible;
  }
`;
const ColumnImage = styled.div`
  position: relative;
  width: 70%;
  height: 800px;
  background-color: aliceblue;
  background-size: cover;
  background-position: center;
  transition: 8s ease;
  transform: scale(1.2);
  &:hover {
    transform: scale(1);
  }
  @media (max-width: 768px) {
    width: 100%;
    height: 400px;
    transform: scale(1);
  }
`;
const GalleryArea = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  transform: none;
  overflow: visible;
  @media (max-width: 768px) {
    height: auto;
    transform: none;
    overflow: visible;
  }
`;
const GalleryAreaBox = styled.div`
  position: absolute;
  width: 80%;
  left: 50%;
  transform: translate(-50%, 0);
  background-color: #ffffff;
  @media (max-width: 768px) {
    width: 95%;
  }
`;
const GalleryAreaBack = styled.div`
  width: 100vw;
  height: 1500px;
  position: relative;
  padding-top: 50px;
  background-color: white;
  overflow: visible;
  text-align: center;
`;
const GalleryBlock = styled.div`
  max-height: 1500px;
  width: 100%;
  overflow-y: auto;
`;

const GalleryTitle = styled.div`
  color: #595959;
  font-size: 24px;
  margin-top: 50px;
  margin-bottom: 30px;
  font-weight: 600;
  @media (max-width: 768px) {
    margin-top: 30px;
    margin-bottom: 20px;
  }
`;
